import { connect } from 'react-redux';
import { CourseAdmin } from './component';
import { selectQueryObject } from '../../../../ReduxStorage/location/selectors';

function mapStateToProps(state) {
  return {
    query: selectQueryObject(state),
  };
}

export const ConnectedCourseAdmin = connect(mapStateToProps)(CourseAdmin);
